// English strings for the demosandbox stream (PD-763 per-browser demo sandbox; PD-770 – PD-789).
// Arabic: ar-demosandbox.ts.
export const enDemosandbox = {
  // ------------------------------------------------------------ API (PD-775)
  'api.demoSandboxBusy': 'Someone else is trying this in the demo right now — try another visitor or wait a moment.',
  // ------------------------------------------------------------ notices (PD-776)
  'demo.sandbox.title': 'Demo: this worked for you only',
  'demo.sandbox.body': 'Nothing was saved. Only this browser sees it, and it is undone after {minutes} minutes without use.',
  'demo.sandbox.fallbackTitle': 'Demo: shown once, not kept',
  'demo.sandbox.fallbackBody': 'Many people are trying the demo right now, so this change was shown once and not kept. The next step starts again from the demo data.',
  // ------------------------------------------------------------ sign-in page list (PD-777)
  'demo.kiosk.samples': 'At the kiosk choose “I have an invitation”, then enter one of these visit references and the name shown:',
  'demo.kiosk.sample': '{reference} with the name {check}',
  // ------------------------------------------------------------ truthful page copy in demo mode (PD-776)
  'demo.pass.rsvpRecorded': 'Thank you. In this demo your reply is shown to you only: your host is not told and nothing is kept.',
  'demo.kiosk.doneBody': 'In this demo nobody is told and nothing is kept: your check-in is shown on this screen only.',
} as const;
